import { setClearAuth } from '../store/slices/authSlice';
import { clearUser } from '../store/slices/userSlice';

// 60 seconds timeout
const SESSION_TIMEOUT = 6 * 60 * 60 * 1000;

export const sessionMiddleware = (store) => (next) => (action) => {
  const result = next(action);

  // Update last activity for any non-auth action
  if (!action.type.startsWith('auth/')) {
    store.dispatch({ type: 'auth/updateLastActivity' });
  }

  return result;
};

export const checkSessionTimeout = (store) => {
  const state = store.getState();
  const { isAuth, lastActivityTime } = state.auth;

  if (isAuth && lastActivityTime) {
    const elapsed = Date.now() - lastActivityTime;
    

    if (elapsed > SESSION_TIMEOUT) {
      
      store.dispatch(setClearAuth()); // Use setClearAuth for timeouts
      store.dispatch(clearUser());
      return true;
    }
  }
  return false;
};